export const getAllRoleService = async () => {
  const URL = `/role`;  
  const query = await fetch(URL)  
  const jsonData = await query.json();  
  return jsonData;
}